import React, { useState } from "react";
import Button from "../../atoms/Button";
import { ReactComponent as Arrow } from "../../svgs/wallet-arrow.svg";

const AccountDetails = ({ onAdd, data }) => {
  const [currentAccount, setCurrentAccount] = useState(0);
  const accounts = data.filter((item) => item.account_status);
  // const accounts = data.filter((item) => item);
  const account = accounts[currentAccount];
  return (
    <div className="account-details flex flex-col">
      <div className="flex gap-x-4 items-center">
        <Button
          disabled={currentAccount <= 0}
          className={` py-1 px-2 h-fit ${
            currentAccount > 0 ? "bg-blue-300" : "bg-gray-200"
          }`}
          varient={"rounded"}
          onClick={() => {
            if (currentAccount > 0) setCurrentAccount(currentAccount - 1);
          }}
        >
          <Arrow
            className={`w-6 h-3 rotate-180  ${
              currentAccount > 0 ? "text-blue-800" : "text-gray-400"
            }`}
          />
        </Button>
        <h4 className="text-xl font-bold">Account Details</h4>
        <Button
          disabled={currentAccount >= accounts.length - 1}
          className={` py-1 px-2 h-fit ${
            currentAccount < accounts.length - 1 ? "bg-blue-300" : "bg-gray-200"
          }`}
          varient={"rounded"}
          onClick={() => {
            if (currentAccount < accounts.length - 1)
              setCurrentAccount(currentAccount + 1);
          }}
        >
          <Arrow
            className={`w-6 h-3 ${
              currentAccount < accounts.length - 1
                ? "text-blue-800"
                : "text-gray-400"
            }`}
          />
        </Button>
      </div>

      {accounts.length === 0 ? (
        <div className="text-center w-72 h-full mt-6">
          <div>No account data found</div>
          <p className="text-xs text-red-500">
            if you already add account! then wait for our admin to verify your
            account
          </p>
          <p className="text-xs text-red-500">
            once the account will verify then account details will show here
          </p>
        </div>
      ) : (
        <div className="w-72">
          <table className="mt-2 text-xs">
            <tbody>
              <tr>
                <td className="text-xs font-medium">Account Owner</td>
                <td className="px-2">-</td>
                <td className=" capitalize">{account?.account_owner_name}</td>
              </tr>
              <tr>
                <td className="text-xs font-medium">Account no</td>
                <td className="px-2">-</td>
                <td>{account?.account_no}</td>
              </tr>
              <tr>
                <td className="text-xs font-medium">Bank</td>
                <td className="px-2">-</td>
                <td className=" capitalize">{account?.bank_name}</td>
              </tr>

              <tr>
                <td className="text-xs font-medium">Location</td>
                <td className="px-2">-</td>
                <td className=" capitalize max-w-[72px] truncate">
                  {account?.bank_address}
                </td>
              </tr>

              <tr>
                <td className="text-xs font-medium">Account Type</td>
                <td className="px-2">-</td>
                <td className=" capitalize">{account?.account_type}</td>
              </tr>

              <tr>
                <td className="text-xs font-medium">IFSC Code</td>
                <td className="px-2">-</td>
                <td>{account?.IFSC_code}</td>
              </tr>

              <tr>
                <td className="text-xs font-medium">Swift Code</td>
                <td className="px-2">-</td>
                <td>{account?.swift_code}</td>
              </tr>

              <tr>
                <td className="text-xs font-medium">MICR Code</td>
                <td className="px-2">-</td>
                <td>{account?.MICR_code}</td>
              </tr>

              <tr>
                <td className="text-xs font-medium">Status</td>
                <td className="px-2">-</td>
                <td>{account?.account_status}</td>
              </tr>

              {/* <tr>
              <td className="text-xs font-bold ">Remarks</td>
              <td className="px-2">-</td>
              <td className="text-red-800 text-wrap">{account?.admin_remarks}</td>
            </tr> */}
            </tbody>
          </table>
          <div className="text-xs font-bold">
            Remarks{" - "}
            <span className="text-red-800 text-wrap">
              {account?.admin_remarks}
            </span>
          </div>
        </div>
      )}

      <Button
        onClick={onAdd}
        className={
          "bg-blue-300 text-blue-800 w-[274px] h-[28px] font-medium rounded-[10px] mt-6"
        }
      >
        + Add Account
      </Button>
    </div>
  );
};

export default AccountDetails;
